<template>
  <div class="container">
    <van-field
      v-model="newValue"
      type="digit"
      label="新密码"
      laceholder="请输入新密码"
    />
    <van-field
      v-model="confirmVlue"
      type="digit"
      label="确认密码"
      laceholder="请确认新密码"
    />
    <div class="confirm-btn" @click="bindPhone">完成</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newValue: "",
      confirmVlue: "",
    };
  },
  methods: {
    bindPhone() {
      if (this.confirmVlue !== this.newValue)
        return this.$toast("两次密码不一致");
      this.$http
        .request(this.$http.pathMap.updatePassword, "post", {
          password: this.confirmVlue,
        })
        .then((res) => {
          this.$router.push("/?code=3");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 10px;
}
.confirm-btn {
  width: 315px;
  height: 38px;
  text-align: center;
  line-height: 38px;
  border-radius: 50px;
  margin: 35px auto;
  background: $base-color;
  color: white;
  font-size: $uni-font-size-lg;
  &:after {
    border-radius: 100px;
  }
}
</style>
